import { type WithRef } from "@common/declarations";
import * as React from "react";

export const INVISIBLE_PROPS: WithIsVisibleHOCProps = {
  isVisible: false
};

export type WithIsVisibleHOCProps = Partial<WithRef<any>> & {
  isVisible: boolean;
};

const withIsVisibleHOC =
  <OriginalProps extends {}>(
    Cmp: React.ComponentType<OriginalProps> | React.ForwardRefExoticComponent<OriginalProps>
  ) =>
  ({ isVisible, ref, ...props }: OriginalProps & WithIsVisibleHOCProps) =>
    isVisible ? <Cmp {...(props as any)} ref={ref} /> : null;
export default withIsVisibleHOC;
